import _str from "shared/util/_str";

export const DESCRIPTIONS = [
	{
		header: _str("BOOST"),
		paragraph: _str("Get a full day’s worth of attention in just 30 minutes."),
	},
];



// WEBPACK FOOTER //
// ./src/apps/boosts/util/constants.js